import { render, staticRenderFns } from "./EstudantesExport_Dados_cloud.vue?vue&type=template&id=99ebcaf8&"
import script from "./EstudantesExport_Dados_cloud.vue?vue&type=script&lang=js&"
export * from "./EstudantesExport_Dados_cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports